import { Badge } from "react-bootstrap";

function EstadoMotivo({ estado }) {
  const estadoConfig = {
    true: {
      label: "Activo",
      color: "var(--color-green) !important",
      textColor: "var(--color-text) !important",
    },
    false: {
      label: "Inactivo",
      color: "var(--color-gray) !important",
      textColor: "var(--color-text) !important",
    },
  };

  // Si estado viene null/undefined → "no definido"
  const config =
    typeof estado === "boolean"
      ? estadoConfig[estado]
      : {
          label: "No definido",
          color: "var(--color-background-3)",
          textColor: "var(--color-text)",
        };

  return (
    <Badge
      style={{
        backgroundColor: config.color,
        color: config.textColor,
      }}
      className="fw-normal fs-6"
    >
      {config.label}
    </Badge>
  );
}

export default EstadoMotivo;
